// import React, { useState } from "react";
// import { View, StyleSheet, Text, TouchableOpacity } from "react-native";

// import { Dim, Colors } from "../../constants/Theme";
// import { Fonts } from "../../constants/fonts";
// import Octicons from "react-native-vector-icons/Octicons";
// import { Overlay } from "react-native-elements";

// const DownloadFilesOverlay = (props) => {
//   return (
//     <Overlay
//       onBackdropPress={props.onBackdropPress}
//       isVisible={props.isVisible}
//       overlayStyle={styles.overlayStyles}
//     >
//       <View style={styles.row}>
//         <Text style={styles.txt}>Game Log</Text>
//         <TouchableOpacity onPress={props.activityLogDownload}>
//           <Octicons name="download" size={Dim.h * 0.03} color={Colors.red} />
//         </TouchableOpacity>
//       </View>

//       <View style={styles.row}>
//         <Text style={styles.txt}>Game Summary</Text>
//         <TouchableOpacity onPress={props.handlePDFdownload}>
//           <Octicons name="download" size={Dim.h * 0.03} color={Colors.red} />
//         </TouchableOpacity>
//       </View>
//       <View style={styles.row}>
//         <Text style={styles.txt}>Team Stats</Text>
//         <TouchableOpacity onPress={props.teamStatsDownload}>
//           <Octicons name="download" size={Dim.h * 0.03} color={Colors.red} />
//         </TouchableOpacity>
//       </View>

//       <View style={styles.row}>
//         <Text style={styles.txt}>Opponent Team Stats</Text>
//         <TouchableOpacity onPress={props.oppStatsDownload}>
//           <Octicons name="download" size={Dim.h * 0.03} color={Colors.red} />
//         </TouchableOpacity>
//       </View>

//       <View style={styles.row}>
//         <Text style={styles.txt}>Player Stats</Text>
//         {props.generalData?.playersStatsA === true ? (
//           <TouchableOpacity onPress={props.playerStatsDownload}>
//             <Octicons name="download" size={Dim.h * 0.03} color={Colors.red} />
//           </TouchableOpacity>
//         ) : (
//           <Octicons name="download" size={Dim.h * 0.03} color={Colors.grey} />
//         )}
//       </View>

//       <View style={styles.row}>
//         <Text style={styles.txt}>Opponent Player Stats</Text>
//         {props.generalData?.playersStatsB === true ? (
//           <TouchableOpacity onPress={props.oppPlayerStatsDownload}>
//             <Octicons name="download" size={Dim.h * 0.03} color={Colors.red} />
//           </TouchableOpacity>
//         ) : (
//           <Octicons name="download" size={Dim.h * 0.03} color={Colors.grey} />
//         )}
//       </View>

//       <View style={styles.row}>
//         <Text style={styles.txt}>MaxPrep data</Text>
//         {props.generalData?.playersStatsA === true ? (
//           <TouchableOpacity onPress={props.maxPrepDownload}>
//             <Octicons name="download" size={Dim.h * 0.03} color={Colors.red} />
//           </TouchableOpacity>
//         ) : (
//           <Octicons name="download" size={Dim.h * 0.03} color={Colors.grey} />
//         )}
//       </View>
//     </Overlay>
//   );
// };

// export default DownloadFilesOverlay;

// const styles = StyleSheet.create({
//   overlayStyles: {
//     borderRadius: 30,
//     alignItems: "center",
//     padding: 20,
//     paddingBottom: 12,
//   },
//   row: {
//     flexDirection: "row",
//     alignItems: "center",
//     width: Dim.w * 0.75,
//     alignSelf: "center",
//     justifyContent: "space-between",
//     marginBottom: 8,
//   },
//   txt: {
//     fontFamily: Fonts.medium,
//     color: Colors.darkBlue,
//     fontSize: Dim.h * 0.02,
//   },
// });

import React from "react";
import './DownloadFilesOverlay.css'; 
import Modal from "react-modal"; 
import DownloadIcon from "@mui/icons-material/Download"; 
Modal.setAppElement("#root"); 

const DownloadFilesOverlay = (props) => {
  return (
    <Modal
      isOpen={props.isVisible}
      onRequestClose={props.onBackdropPress}
      className="overlayStyles"
      overlayClassName="overlayBackground"
    >
      <div className="row">
        <span className="txt">Game Log</span>
        <button className= 'dwnldBtn' onClick={props.activityLogDownload}>
          <DownloadIcon style={{ color: "red", fontSize: 24 }} />
        </button>
       
      </div>

      <div className="row">
        <span className="txt">Game Summary</span>
        <button className= 'dwnldBtn' onClick={props.handlePDFdownload}>
          <DownloadIcon style={{ color: "red", fontSize: 24 }} />
        </button>
      </div>

      <div className="row">
        <span className="txt">Team Stats</span>
        <button className= 'dwnldBtn' onClick={props.teamStatsDownload}>
          <DownloadIcon style={{ color: "red", fontSize: 24 }} />
        </button>
      </div>

      <div className="row">
        <span className="txt">Opponent Team Stats</span>
        <button className= 'dwnldBtn' onClick={props.oppStatsDownload}>
          <DownloadIcon style={{ color: "red", fontSize: 24 }} />
        </button>
      </div>

      <div className="row">
        <span className="txt">Player Stats</span>
        {props.generalData?.playersStatsA === true ? (
          <button className= 'dwnldBtn' onClick={props.playerStatsDownload}>
            <DownloadIcon style={{ color: "red", fontSize: 24 }} />
          </button>
        ) : (
          <DownloadIcon style={{ color: "grey", fontSize: 24 }} />
        )}
      </div>

      <div className="row">
        <span className="txt">Opponent Player Stats</span>
        {props.generalData?.playersStatsB === true ? (
          <button className= 'dwnldBtn' onClick={props.oppPlayerStatsDownload}>
            <DownloadIcon style={{ color: "red", fontSize: 24 }} />
          </button>
        ) : (
          <DownloadIcon style={{ color: "grey", fontSize: 24 }} />
        )}
      </div>

      <div className="row">
        <span className="txt">MaxPrep data</span>
        {props.generalData?.playersStatsA === true ? (
          <button className= 'dwnldBtn' onClick={props.maxPrepDownload}>
            <DownloadIcon style={{ color: "red", fontSize: 24 }} />
          </button>
        ) : (
          <DownloadIcon style={{ color: "grey", fontSize: 24 }} />
        )}
      </div>
    </Modal>
  );
};

export default DownloadFilesOverlay;
